// extracted by mini-css-extract-plugin
export default {"accordion":"_1hZuNaoWEKBpDrzmgU-Fve","title":"_3hgeN13Lhyj_8KGJczG6O8","noBoarder":"MIj1n9v0fwtufNLl1GnD3"};